<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Notifications</p>
                    </div>
                    <div class="card-content">
                        
                        <div class="columns is-multiline">
                            <div class="column is-full" >
                                <div class="card">
                                    <div class="card-header">
                                        <p class="card-header-title">Teacher's App</p>
                                        <a class="button is-primary" v-on:click="addNotificationForTeacherForm()" style="margin: 5px;" v-show="!addNotificationTeacher">Add Notification</a>
                                        <a class="button is-warning" v-on:click="closeAddNotificationForTeacherForm()" style="margin: 5px;" v-show="addNotificationTeacher">Close Add Notification</a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content" v-show="addNotificationTeacher">                                    
                                            <add-notification-teacher></add-notification-teacher>
                                        </div>
                                        <loading :active.sync="isLoading" 
                                            :can-cancel="false" 
                                            :is-full-page="true">
                                        </loading>
                                        <div>
                                            <data-list v-bind:dataList="dataList" class="columns is-multiline"></data-list>
                                            <!-- <div class="column is-half box" v-for="data in notificationList" :key="data._id" v-bind:class="isActive(data.status)">
                                                <div class="card-header">
                                                    <p class="card-header-title">{{ data.title }}</p>
                                                </div>
                                                <div class="card-content">
                                                    <div class="content">
                                                        {{ data.message }}
                                                        <br/>
                                                        Repeat on: {{ data.repeatOn }}
                                                        <br/>
                                                        Time: {{ data.repeatTime }}
                                                    </div>
                                                </div>
                                                <footer class="card-footer">
                                                    <a href="#" class="card-footer-item" v-on:click="goPositiveDetails(student._id,student.firstName + ' ' + student.lastName)">Edit</a>
                                                    <a href="#" class="card-footer-item" v-on:click="deleteNotification(data)">Delete</a>
                                                </footer>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                       
                    </div>
                </div>
                <br />
            </div>
        </div>
    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import AddNotificationTeacher from '../Notifications/AddNotificationTeacher';
import DataList from '../Notifications/DataList';
import axios from 'axios'
import "../public/style.scss";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'



export default {
    name: "Notifications",
    components: {
        TopMenu,
        Loading,
        AddNotificationTeacher,
        DataList
    },
    data() {
        return {
            data : {
                repeatOn : []
            },
            dataList: [],
            input: { },
            isLoading: false,
            isLoading1: false,
            addNotificationTeacher: false,
            dateDisplay: '',
            actionDate: '',
            actionYear: '',
            notificationList: [],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.actionYear = currentDate.getFullYear()
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = this.actionYear + "" + currentMonth + "" + currentDay;
        console.log("actionDate: " + this.actionDate)

        var month = currentDate.getMonth();
        var dayOfWeek = currentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = "";
        switch (month){
            case 0:
                monthDisplay = "January";
                break;
            case 1:
                monthDisplay = "February";
                break;
            case 2:
                monthDisplay = "March";
                break;
            case 3:
                monthDisplay = "April";
                break;
            case 4:
                monthDisplay = "May";
                break;
            case 5:
                monthDisplay = "June";
                break;
            case 6:
                monthDisplay = "July";
                break;
            case 7:
                monthDisplay = "August";
                break;
            case 8:
                monthDisplay = "September";
                break;
            case 9:
                monthDisplay = "October";
                break;
            case 10:
                monthDisplay = "November";
                break;
            case 11:
                monthDisplay = "December";
                break;
            default:
                monthDisplay = "January";
                break;
        }

        this.dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
    },
    mounted(){
        this.getNotifications()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },
        editData(){
            this.isEditing = true;
        },
        addNotificationForTeacherForm(){
            this.addNotificationTeacher = true;
        },
        closeAddNotificationForTeacherForm(){
            this.addNotificationTeacher = false;
        },
        getNotifications(){
            let self = this;
            this.isLoading = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/notifications/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        target: 1   //for teachers' notifications
                    }
                })
                .then(response => {
                    console.log("imin response length: " + response.data.dataList.length)
                    //console.log(response)
                    //lines below are used to convert the repeatOn saved data in string to array
                    for (var i = 0; i < response.data.dataList.length; i++){
                        var myRepeatOn = response.data.dataList[i].repeatOn.split(",");
                        response.data.dataList[i].repeatOn = myRepeatOn;
                    }
                    self.dataList = response.data.dataList
                    self.isLoading = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading = false
                })
        }, 
        deleteNotification(data){
            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "tttThis notification (" + data.title + ") will be permanently removed.",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                console.log("imini result")
                console.log(result)
                if (result.value){

                    this.input.email = localStorage.getItem('email')
                    this.input.notificationID = data._id

                    const dataIndex = this.notificationList.indexOf(data);
                    this.notificationList.splice(dataIndex, 1);

                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.MY_URL + '/api/notifications/remove', this.input)
                        .then(response => {

                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                        })
                        .catch(e => {
                            console.log(e.response)
                            if (e.response.status === 401) {
                                console.log("salah login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })
                }
            })

        },
        goDbGroup() {
            this.$router.push({
                name: "DbGroupMain"
            });
        },
    }
};
</script>

<style scoped>
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications/Home.vue